/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addScalarDependencies } from './dependenciesAddScalar.generated.js';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated.js';
import { expDependencies } from './dependenciesExp.generated.js';
import { iDependencies } from './dependenciesI.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated.js';
import { tauDependencies } from './dependenciesTau.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createFft } from '../../factoriesAny.js';
export var fftDependencies = {
  addScalarDependencies,
  divideScalarDependencies,
  expDependencies,
  iDependencies,
  matrixDependencies,
  multiplyScalarDependencies,
  tauDependencies,
  typedDependencies,
  createFft
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesFft.generated.js
// module id = 538
// module chunks = 2